// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-backgroud[data-v-42497231]{background:#25272a;padding:5px 10px}", ""]);
// Exports
module.exports = exports;
